import { createAction } from 'redux-actions';
import Types from './types';

export const getAuditLogsRequest = createAction(Types.GET_AUDIT_LOGS_REQUEST);
export const getAuditLogsFulfilled = createAction(
  Types.GET_AUDIT_LOGS_FULFILLED
);
export const getAuditLogsRejected = createAction(Types.GET_AUDIT_LOGS_REJECTED);

export const getContextAuditLogsRequest = createAction(
  Types.GET_CONTEXT_AUDIT_LOGS_REQUEST
);
export const getContextAuditLogsFulfilled = createAction(
  Types.GET_CONTEXT_AUDIT_LOGS_FULFILLED
);
export const getContextAuditLogsRejected = createAction(
  Types.GET_CONTEXT_AUDIT_LOGS_REJECTED
);
